export default "__VITE_ASSET__uDP9CGDe__"